import React, { useEffect } from "react";

import Filter from "./Section/Filter";
import { BannerManagementTable } from "./Section/banner-management-table";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import { useSetState } from "../../utils/hooks";
import Button from "../../components/ui/Button/Button";
import { useNavigate } from "react-router-dom";

function BannerManagementPage() {
  const navigate = useNavigate();
  const [filter, dispatchFilter] = useSetState();
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [sortFilter, setSortFilter] = React.useState({});
  const filters = { ...selectedFilter, ...sortFilter };
  const onSubmitFilter = () => {
    setSelectedFilter(filter);
  };

  const onResetFilter = () => {
    setSelectedFilter({});
  };

  useEffect(() => {
    if (sortFilter?.orderBy !== undefined) {
      dispatchFilter({
        orderBy: sortFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortFilter?.orderBy]);

  const handleRegister = () => {
    navigate("/banner-management/register");
  };

  return (
    <>
      <div>
        <TitlePage marginBottom="mb-0" title="배너 관리 (ONEDAY Mall)" />
        <div className="flex mt-0 mb-4 justify-end">
          <Button onClick={handleRegister} primary text="배너 등록" />
        </div>
        <Filter
          onSubmitFilter={onSubmitFilter}
          onFilter={dispatchFilter}
          onResetFilter={onResetFilter}
        />{" "}
        <div className="mt-4">
          <BannerManagementTable onSort={setSortFilter} filter={filters} />
        </div>
      </div>
    </>
  );
}

export default BannerManagementPage;
